import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CssSpinner from '../cssSpinner';
import './styles.scss';

class ExpandPanel extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isHeaderExpanded: true,
            isContentExpanded: false,
            loadingHeight: -1,
        }
    }

    componentWillReceiveProps(nextProps) {
        const {
            isHeaderExpanded,
        } = this.state;

        const {
            children,
            isLoading,
        } = nextProps;

        // Hide expand panel header
        if (children.length === 0 && isHeaderExpanded && !isLoading) {
            this.setState({
                isHeaderExpanded: false,
            })
        }

        // Show expand panel header
        if (children.length !== 0 && !isHeaderExpanded && !isLoading) {
            this.setState({
                isHeaderExpanded: true,
            })
        }

        // Loading started
        if (!this.props.isLoading && isLoading) {
            this.setState({
                loadingHeight: this.props.expandHeight,
            });
        }

        // Loading finished
        if (this.props.isLoading && !isLoading) {
            this.setState({
                loadingHeight: -1,
            });
        }
    }

    onClick = () => {
        const {
            isContentExpanded,
        } = this.state;

        this.setState({
            isContentExpanded: !isContentExpanded,
        })
    }

    renderIcon = () => {
        const {
            isLoading,
        } = this.props;

        const {
            isContentExpanded,
        } = this.state;

        if (isLoading && !isContentExpanded) {
            return (
                <CssSpinner
                    className="bs-expand-panel__title-spinner"
                    size="small"
                    theme="dark"
                />
            )
        }

        return (
            <div className="bs-expand-panel__title-icon" />
        )
    }

    render() {
        const {
            isHeaderExpanded,
            isContentExpanded,
            loadingHeight,
        } = this.state;

        const {
            children,
            isLoading,
            title,
            expandHeight,
        } = this.props;

        let height = isContentExpanded ? expandHeight : 0;

        if (isContentExpanded && loadingHeight !== -1) {
            height = loadingHeight
        }

        const contentStyle = { height };

        return (
            <div
                className={classNames(
                    'bs-expand-panel',
                    {
                        'bs-expand-panel--hidden': !isHeaderExpanded && !isLoading,
                    },
                )}
            >
                <button
                    className={classNames(
                        'bs-expand-panel__header',
                        {
                            'bs-expand-panel__expand': !isContentExpanded,
                            'bs-expand-panel__header--hidden': !isHeaderExpanded,
                        },
                    )}
                    onClick={this.onClick}
                    disabled={!isHeaderExpanded}
                >
                    <span className="bs-expand-panel__title">{title}</span>
                    { this.renderIcon() }
                </button>
                <div
                    className={classNames(
                        'bs-expand-panel__content',
                        {},
                    )}
                    style={contentStyle}
                >
                    {
                        isContentExpanded && isLoading ?
                            <div className="bs-expand-panel__loading">
                                <CssSpinner
                                    className="bs-expand-panel__spinner"
                                    size="medium"
                                    theme="dark"
                                />
                            </div> : null
                    }

                    <div
                        className="bs-expand-panel__content-wrapper"
                        ref={(content) => { this.contentContainer = content; }}
                    >
                        { children }
                    </div>

                </div>
            </div>
        )
    }
}

ExpandPanel.defaultProps = {
    isLoading: false,
    children: null,
}

ExpandPanel.propTypes = {
    isLoading: PropTypes.bool,
    title: PropTypes.string.isRequired,
    children: PropTypes.node,
    expandHeight: PropTypes.number.isRequired,
}

export default ExpandPanel;



// WEBPACK FOOTER //
// /src/js/common/expandPanel/ExpandPanel.jsx